import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

interface AppLayoutProps {
  children: React.ReactNode;
  hideFooter?: boolean;
}

export default function AppLayout({ children, hideFooter = false }: AppLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-background yarn-bg">
      <Navbar />
      <main className="flex-1">
        {children}
      </main>
      {!hideFooter && <Footer />}
    </div>
  );
}